import { css } from 'styled-components'
import { MEDIA, TOUCH_TARGET } from '~/common/styles/responsive'

/**
 * The frame every small confirm / notice dialog shares: a centred card with a
 * content column of `minWidth`–`maxWidth` px.
 *
 * It used to be copy-pasted into four feature folders with slightly different
 * numbers. Each copy now composes this and adds only what is its own.
 *
 * `actionBasis` is the width each action button asks for on desktop (it used to
 * be a fixed width; now it is a basis the buttons can shrink from).
 *
 * Phones: the card keeps 16px from each screen edge (never wider than
 * calc(100vw - 32px)), the column drops its fixed minimum so it can shrink, and
 * buttons in `.dialog-actions` split the row evenly at a 44px tap height.
 */
export const notifyDialogFrame = ({ maxWidth = 340, minWidth = 240, innerMargin, actionBasis = 0 } = {}) => css`
	.MuiDialog-paper {
		margin: 8px;

		> .MuiBox-root {
			min-width: ${minWidth}px;
			max-width: ${maxWidth}px;
			${innerMargin ? `margin: ${innerMargin};` : ''}
		}

		${MEDIA.phone} {
			margin: 16px;
			max-width: calc(100vw - 32px);

			> .MuiBox-root {
				min-width: 0;
				max-width: none;
				${innerMargin ? 'margin: 20px 16px;' : ''}
			}
		}
	}

	.dialog-actions {
		display: flex;
		gap: 16px;

		> * {
			flex: 1 1 ${actionBasis}px;
			min-width: 0;
		}

		${MEDIA.phone} {
			gap: 12px;

			> * {
				flex-basis: 0;
			}

			.MuiButton-root {
				min-height: ${TOUCH_TARGET}px;
			}
		}
	}

	.dialog-close {
		flex: none;
		width: ${TOUCH_TARGET}px;
		height: ${TOUCH_TARGET}px;
		margin: -10px -10px 0 8px;
		padding: 10px;
	}
`

export const notifyDialogStyle = css`
	${notifyDialogFrame({ maxWidth: 340 })}

	.MuiDialog-paper > .MuiBox-root .header .MuiTypography-root {
		color: ${({ theme }) => theme.palette.primary.main};
	}
`
